import React, { useEffect, useState } from 'react';
import { MessageBanner } from '@glowforge/gf-styled/components/message-banner';
import { useMessageCenter } from '../../context/MessageCenterProvider';

const MessageBannerRebrand = () => {

  const messageCenter = useMessageCenter();
  const [message, setMessage] = useState(null);

  useEffect(() => {
    messageCenter.getMessage().then(setMessage);
  }, [messageCenter]);

  /* eslint-disable-next-line react/jsx-props-no-spreading */
  return <MessageBanner {...message} />;
};

export default MessageBannerRebrand;
